import { isPermalinkPath } from '@/features/seo-listing/consts';

/**
 * Breadcrumb fandom crumb («Фанфики / {Fandom}») must leave character/pairing
 * identity. Soft handleFandomsChange keeps selectedCharacters and stale H1 on
 * query listings; permalink SSR/soft-SEO already hard-navigates.
 */
export const shouldHardResetFandomBreadcrumbNavigation = ({
  isNextPathPermalink,
  browserPathname,
  browserSearch,
  selectedCharactersCount,
  selectedPairingCharactersCount,
}: {
  isNextPathPermalink: boolean;
  browserPathname: string;
  browserSearch: string;
  selectedCharactersCount: number;
  selectedPairingCharactersCount: number;
}): boolean => {
  if (isNextPathPermalink || isPermalinkPath(browserPathname)) {
    return true;
  }

  if (selectedCharactersCount > 0 || selectedPairingCharactersCount > 0) {
    return true;
  }

  return /(?:^|[?&])(?:characters|pairingCharacters)=/.test(browserSearch);
};
